// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setMonthlyReports } from 'redux/modules/protection'

import {
  getReportCodes,
  reduceLicensees,
  reduceReports,
} from './helpers'

import {
  assembleQuery,
  fetchWrapper,
} from 'helpers/api'

// NOTE - we throw err to the caller and don't deal with it here.

const initializeMonthlyReports = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        monthlyReports,
      } = getState().protection

      // if the data isn't expired, we don't need to do anything
      if (monthlyReports.dataExpiration > Date.now()) {
        return (
          !monthlyReports.reports.length
            ? 'No Available Reports.'
            : null
        )
      }

      // get all the licensees/owners for this user
      const ownerData = await fetchWrapper('/owner')

      // creates a cleaned up list of unique company_name/owner_code entries
      const licensees = reduceLicensees(ownerData)

      // get all unique report codes from that
      const reportCodes = getReportCodes(ownerData)

      let reports = []

      if (reportCodes.length > 0) {
        const query = assembleQuery([{
          field: 'owners',
          value: reportCodes.join(','),
        }])

        // fetches the reports we want to present in the UI
        const allReports = await fetchWrapper(`/protectionExport${query}`)

        // reduces the reports list so each record is a unique year/month.
        // The report codes are grouped for each reduced record.
        reports = reduceReports(allReports)
      }

      // add the data to redux
      dispatch(setMonthlyReports({
        licensees,
        reportCodes,
        reports,
      }))

      // return a message for the reports
      return (
        !reports.length
          ? 'No Available Reports.'
          : null
      )
    })
  )
)

export default initializeMonthlyReports
